import { ViteReactSSG } from 'vite-react-ssg/single-page'
import React from 'react'
import App from './App'
import './index.css'

export const createRoot = ViteReactSSG(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)